var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var ScreenRotation = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 612 612" }, props),
    React.createElement("g", null,
        React.createElement("g", null,
            React.createElement("path", { d: "M419.475,63.75c84.15,38.25,142.8,119.85,153,216.75h38.25C595.425,122.4,465.375,0,304.725,0c-5.1,0-10.2,0-17.85,0\n                l96.9,96.9L419.475,63.75z M258.825,43.35c-15.3-15.3-38.25-15.3-53.55,0l-163.2,163.2c-15.3,15.3-15.3,38.25,0,53.55l306,306\n                c15.301,15.301,38.25,15.301,53.551,0L564.825,402.9c15.301-15.301,15.301-38.25,0-53.551L258.825,43.35z M376.125,540.6l-306-306\n                l163.2-163.2l306,306L376.125,540.6z M189.975,548.25c-84.15-38.25-142.8-119.85-153-216.75h-35.7\n                c12.75,158.1,142.8,280.5,303.45,280.5c5.1,0,10.2,0,17.85,0l-96.899-96.9L189.975,548.25z" }))))); };
export default ScreenRotation;
//# sourceMappingURL=ScreenRotation.js.map